const BUSINESS_TYPES = [
  {
    label: "Maatalouskauppias / Maatilakauppa",
    value: "Agricultural Merchant / Farm Store",
    id: "agricultural_merchant_farm_store",
  },
  {
    label: "Eläinsuoja / Hyväntekeväisyys",
    value: "Animal Shelter / Charity",
    id: "animal_shelter_charity",
  },
  {
    label: "Taustatarha",
    value: "Backgrounder Lot",
    id: "backgrounder_lot",
  },
  {
    label: "Naudanlihantuottaja",
    value: "Beef Producer",
    id: "beef_producer",
  },
  { label: "Broilerit", value: "Broilers", id: "broilers" },
  {
    label: "Ostoryhmä",
    value: "Buying Group",
    id: "buying_group",
  },
  {
    label: "Vasikantuotanto",
    value: "Calf Production",
    id: "calf_production",
  },
  {
    label: "Vasikkafarmi/Kehittäjä",
    value: "Calf Ranch/Developer",
    id: "calf_ranch_developer",
  },
  { label: "Karjanostaja", value: "Cattle Buyer", id: "cattle_buyer" },
  {
    label: "Sopimuskasvattaja",
    value: "Contract Grower",
    id: "contract_grower",
  },
  { label: "Osuuskunta", value: "Cooperative", id: "cooperative" },
  {
    label: "Yritystoimisto",
    value: "Corporate Office",
    id: "corporate_office",
  },
  {
    label: "Lehmä/Vasikkatoiminta",
    value: "Cow/Calf Operation",
    id: "cow_calf_operation",
  },
  {
    label: "Maidontuotanto",
    value: "Dairy Production",
    id: "dairy_production",
  },
  {
    label: "Jakelija / Agentti",
    value: "Distributor / Agent",
    id: "distributor_agent",
  },
  { label: "Rehumylly", value: "Feed Mill", id: "feed_mill" },
  { label: "Ruokintapiha", value: "Feedyard", id: "feedyard" },
  {
    label: "Kasvattaja/Kasvatuspiha",
    value: "Grower/Growyard",
    id: "grower_growyard",
  },
  { label: "Hautomo", value: "Hatchery", id: "hatchery" },
  {
    label: "Hiehotuotanto",
    value: "Heifer Production",
    id: "heifer_production",
  },
  {
    label: "Munivien integraatio",
    value: "Layer Integration",
    id: "layer_integration",
  },
  { label: "Munivat kanat", value: "Layers", id: "layers" },
  { label: "Media", value: "Media", id: "media" },
  {
    label: "Maitoosuuskunta/Ostaja",
    value: "Milk Cooperative/Buyer",
    id: "milk_cooperative_buyer",
  },
  {
    label: "Sekatuottaja/Muu tuottaja",
    value: "Mixed/Other Producer",
    id: "mixed_other_producer",
  },
  {
    label: "Ravinnetoimittaja",
    value: "Nutrient Supplier",
    id: "nutrient_supplier",
  },
  {
    label: "Pakkaaja/Jalostaja",
    value: "Packer/Processor",
    id: "packer_processor",
  },
  {
    label: "Lemmikkieläinkauppa",
    value: "Pet Retail Outlet",
    id: "pet_retail_outlet",
  },
  { label: "Apteekki", value: "Pharmacy", id: "pharmacy" },
  {
    label: "Siipikarjanjalostaja",
    value: "Poultry Breeder",
    id: "poultry_breeder",
  },
  {
    label: "Siipikarjan integraattori",
    value: "Poultry Integrator",
    id: "poultry_integrator",
  },
  { label: "Lammastuottaja", value: "Sheep Producer", id: "sheep_producer" },
  {
    label: "Varastointitoiminta",
    value: "Stocker Operation",
    id: "stocker_operation",
  },
  {
    label: "Karjapiha/Myyntilato",
    value: "Stockyard/Salebarn",
    id: "stockyard_salebarn",
  },
  { label: "Sikatuottaja", value: "Swine Producer", id: "swine_producer" },
  { label: "Kalkkunat", value: "Turkeys", id: "turkeys" },
  {
    label: "Yliopisto / Koulutus",
    value: "University / Education",
    id: "university_education",
  },
  {
    label: "Eläinlääkäriasema",
    value: "Veterinary Practice",
    id: "veterinary_practice",
  },
  {
    label: "Tukkumyyjä / Vähittäiskauppias",
    value: "Wholesaler / Retailer",
    id: "wholesaler_retailer",
  },
  { label: "Villanostaja", value: "Wool Buyer", id: "wool_buyer" },
];

const FIELDS = {
  common: {
    errors: {
      required: "Pakollinen",
    },
  },
  salutation: {
    label: "Puhuttelumuoto",
    placeholder: "Valitse puhuttelumuoto",
    errors: {
      required: "Puhuttelumuoto on pakollinen",
      invalid: "Valitse kelvollinen puhuttelumuoto",
    },
  },
  firstName: {
    label: "Etunimi",
    placeholder: "Matti",
    errors: {
      authenticatedNameUpdateTrial:
        "Olet kirjautunut sisään, eikä nimeäsi voi muuttaa.",
      required: "Etunimi on pakollinen",
      minLength: "Etunimen on oltava vähintään 2 merkkiä",
      maxLength: "Etunimen on oltava enintään 50 merkkiä",
    },
  },
  lastName: {
    label: "Sukunimi",
    placeholder: "Meikäläinen",
    errors: {
      authenticatedNameUpdateTrial:
        "Olet kirjautunut sisään, eikä nimeäsi voi muuttaa.",
      required: "Sukunimi on pakollinen",
      minLength: "Sukunimen on oltava vähintään 2 merkkiä",
      maxLength: "Sukunimen on oltava enintään 50 merkkiä",
    },
  },
  email: {
    label: "Sähköposti",
    placeholder: "matti.meikalainen@esimerkki.fi",
    description:
      "Anna henkilökohtainen sähköpostiosoitteesi, ei jaettua sähköpostiosoitetta.",
    prefixWarningTitle: "Jaettu postilaatikko havaittu",
    prefixWarningDescription:
      "Suosittelemme henkilökohtaisen sähköpostiosoitteen käyttöä paremman ja henkilökohtaisemman käyttökokemuksen saamiseksi",
    errors: {
      authenticatedEmailUpdateTrial:
        "Olet kirjautunut sisään, eikä sähköpostiosoitettasi voi muuttaa.",
      required: "Sähköposti on pakollinen",
      invalidEmail: "Anna kelvollinen sähköpostiosoite",
      emailAssociatedWithYourAccount:
        "Sähköpostiosoitteesi on liitetty tilillesi, eikä sitä voi muuttaa.",
    },
  },
  confirmEmail: {
    label: "Vahvista sähköposti",
    placeholder: "matti.meikalainen@esimerkki.fi",
    errors: {
      authenticatedEmailUpdateTrial:
        "Olet kirjautunut sisään, eikä sähköpostiosoitettasi voi muuttaa.",
      required: "Sähköpostin vahvistus on pakollinen",
      invalidEmail: "Anna kelvollinen sähköpostiosoite",
      emailMatchError: "Sähköpostiosoitteet eivät täsmää",
    },
  },
  password: {
    label: "Salasana",
    placeholder: "Anna salasanasi",
    errors: {
      required: "Salasana on pakollinen",
    },
  },
  confirmPassword: {
    label: "Vahvista salasana",
    placeholder: "Vahvista salasanasi",
    errors: {
      required: "Salasanan vahvistus on pakollinen",
      passwordMatchError: "Salasanat eivät täsmää",
    },
  },
  addressLine1: {
    label: "Osoiterivi 1",
    placeholder: "Esimerkkikatu 123",
    errors: {
      required: "Osoiterivi 1 on pakollinen",
      minLength: "Osoiterivin 1 on oltava vähintään 5 merkkiä",
      maxLength: "Osoiterivin 1 on oltava enintään 100 merkkiä",
    },
  },
  addressLine2: {
    label: "Osoiterivi 2",
    placeholder: "Asunto 4B",
    errors: {
      required: "Osoiterivi 2 on pakollinen",
      maxLength: "Osoiterivin 2 on oltava enintään 100 merkkiä",
    },
  },
  city: {
    label: "Kaupunki / Kunta",
    placeholder: "Helsinki",
    errors: {
      required: "Kaupunki / Kunta on pakollinen",
      minLength: "Kaupunki / Kunta on oltava vähintään 2 merkkiä",
      maxLength: "Kaupunki / Kunta on oltava enintään 50 merkkiä",
    },
  },
  country: {
    label: "Maa",
    placeholder: "Valitse maa",
    errors: {
      required: "Maa on pakollinen",
      invalid: "Valitse kelvollinen maa",
    },
  },
  state: {
    label: "Osavaltio",
    placeholder: "Valitse osavaltio",
    errors: {
      required: "Osavaltio on pakollinen",
      invalid: "Valitse kelvollinen osavaltio",
    },
  },
  jurisdiction: {
    label: "Luvan toimivalta-alue",
    placeholder: "Valitse luvan toimivalta-alue",
    errors: {
      required: "Luvan toimivalta-alue on pakollinen",
      invalid: "Valitse kelvollinen toimivalta-alue",
    },
  },
  zipCode: {
    label: "Postinumero",
    placeholder: "00100",
    errors: {
      required: "Postinumero on pakollinen",
      invalid: "Anna kelvollinen postinumero",
    },
  },
  role: {
    label: "Rooli",
    placeholder: "Valitse roolisi",
    errors: {
      required: "Valitse roolisi",
      invalid: "Valitse kelvollinen rooli",
    },
  },
  businessType: {
    label: "Yritystyyppi",
    placeholder: "Valitse yritystyyppi",
    errors: {
      required: "Yritystyyppi on pakollinen",
      invalid: "Valitse kelvollinen yritystyyppi",
    },
  },
  businessName: {
    label: "Yrityksen nimi",
    placeholder: "Anna yrityksen nimi",
    errors: {
      required: "Yrityksen nimi on pakollinen",
      minLength: "Yrityksen nimen on oltava vähintään 2 merkkiä",
      maxLength: "Yrityksen nimen on oltava enintään 100 merkkiä",
    },
  },
  businessSearch: {
    label: "Yrityksen haku:",
    addNewAccount: "Lisää uusi yritystili",
    canNotFindBusiness: "Etkö löydä yritystäsi?",
    guideline:
      "Anna postinumerosi ja valitse sitten alla olevasta luettelosta.",
    guidelineForNameSearch:
      "Anna yrityksen koko nimi ja valitse sitten luettelosta.",
    placeholder: "Missä työskentelet?",
    noResults: "Tuloksia ei löytynyt",
    searching: "Haetaan...",
    selectedBusinessHeading: "Valittu yritys:",
    selectedBusinessNotCorrect: "Eikö ole oikein?",
    selectedBusinessTryAgain: "Yritä uudelleen",
    selectedBusinessDismiss: "Hylkää yritys",
    resultsFound: {
      singular: "1 yritys löytyi",
      plural: "Useita yrityksiä löytyi",
    },
    errors: {
      network:
        "Yhteyden muodostamisessa yrityshaun palveluun on ongelmia. Yritä myöhemmin uudelleen.",
    },
  },
  explicitConsent: {
    label:
      "Valitsemalla tämän ruudun hyväksyn Elancon käyttöehdot ja vahvistan, että Elanco kerää ja käsittelee henkilötietojani Elancon tietosuojakäytännön mukaisesti",
    errors: {
      required: "Sähköpostisuostumus vaaditaan",
    },
  },
  explicitSmsConsent: {
    label:
      "Rastittamalla tämän ruudun hyväksyn markkinointiviestien vastaanottamisen Elancolta tekstiviestillä/SMS:llä.",
    errors: {
      required: "SMS-suostumus vaaditaan",
    },
  },
  telephone: {
    label: "Henkilökohtainen puhelin",
    placeholder: "Anna henkilökohtainen puhelinnumerosi",
    dialCodeLabel: "Koodi",
    dialCodePlaceholder: "Hae maata…",
    errors: {
      invalid: "Anna kelvollinen puhelinnumero.",
    },
  },
  businessTelephone: {
    label: "Yrityksen puhelin",
    placeholder: "Anna yrityksen puhelinnumero",
    dialCodeLabel: "Koodi",
    dialCodePlaceholder: "Hae maata…",
    errors: {
      invalid: "Anna kelvollinen puhelinnumero.",
    },
  },
  professionalNumber: {
    label: "Ammatillinen numero",
    placeholder: "1234567",
    errors: {
      required: "Anna ammatillinen numero",
      maxLength: "Syöte ylittää merkkirajoituksen",
    },
  },
  addressSearch: {
    errors: {
      required: "Tämä kenttä on pakollinen",
    },
  },
  businessSearchField: {
    errors: {
      required: "Tämä kenttä on pakollinen",
    },
  },
  checkbox: {
    errors: {
      required: "Tämä kenttä on pakollinen",
    },
  },
  checkboxGroup: {
    errors: {
      required: "Tämä kenttä on pakollinen",
    },
  },
  combobox: {
    errors: {
      required: "Tämä kenttä on pakollinen",
    },
  },
  datePicker: {
    errors: {
      required: "Tämä kenttä on pakollinen",
    },
  },
  dateRange: {
    errors: {
      required: "Tämä kenttä on pakollinen",
    },
  },
  dateTime: {
    errors: {
      required: "Tämä kenttä on pakollinen",
    },
  },
  emailField: {
    errors: {
      required: "Tämä kenttä on pakollinen",
    },
  },
  fileInput: {
    errors: {
      required: "Valitse tiedosto",
    },
  },
  number: {
    errors: {
      required: "Anna numero",
      minValue: "Anna arvo, joka on suurempi kuin vähimmäisarvo",
      maxValue: "Anna arvo, joka on pienempi kuin enimmäisarvo",
    },
  },
  passwordField: {
    errors: {
      required: "Tämä kenttä on pakollinen",
    },
  },
  rangeSlider: {
    errors: {
      required: "Tämä kenttä on pakollinen",
    },
  },
  select: {
    errors: {
      required: "Tämä kenttä on pakollinen",
    },
  },
  telephoneField: {
    errors: {
      required: "Anna vain numeroita",
      invalidTelephone: "Anna kelvollinen puhelinnumero",
      invalidFormat: "Virheellinen numeromuoto",
    },
  },
  text: {
    errors: {
      required: "Käytä vain kirjaimia (A-Ö), numeroita (0-9) ja ei symboleita",
      maxLength: "Syöte ylittää merkkirajoituksen",
      minLength: "Syötteen on oltava vähintään 2 merkkiä",
    },
  },
  textarea: {
    characters: "merkkiä",
  },
  time: {
    errors: {
      required: "Tämä kenttä on pakollinen",
    },
  },
  form: {
    errors: {
      generic: "Lomakkeen lähettämisessä tapahtui virhe. Yritä uudelleen.",
      reportAnIssue: "Ilmoita ongelmasta.",
      configuration: "Määritysvirhe",
      noFormQuestionsAvailable: "Lomakenimikkeitä ei ole saatavilla.",
      formComponentLoad:
        "Lomakekomponenttia ei voitu ladata tukemattoman kentän vuoksi.",
      code: "Koodi",
      type: "Tyyppi",
      missingRequiredFields:
        "Lomakkeesta puuttuu pakolliset kentät (Sähköposti ja/tai Suostumus). Ota yhteyttä järjestelmänvalvojaan lomakkeen määritysten korjaamiseksi.",
    },
  },
};

const ROLES = [
  { value: "Academic", label: "Akateeminen", id: "academic" },
  {
    value: "Animal Welfare - Other",
    label: "Eläintensuojelu - Muu",
    id: "animal_welfare_other",
  },
  {
    value: "Animal Welfare - Retail Staff",
    label: "Eläintensuojelu - Myymälähenkilöstö",
    id: "animal_welfare_retail_staff",
  },
  {
    value: "Animal Welfare - Vet",
    label: "Eläintensuojelu - Eläinlääkäri",
    id: "animal_welfare_vet",
  },
  {
    value: "Animal Welfare - Vet Nurse",
    label: "Eläintensuojelu - Eläinhoitaja",
    id: "animal_welfare_vet_nurse",
  },
  {
    value: "Animal Welfare - Volunteer",
    label: "Eläintensuojelu - Vapaaehtoinen",
    id: "animal_welfare_volunteer",
  },
  {
    value: "Beef / Feedlot Extension",
    label: "Nauta / Ruokintapiha-laajennus",
    id: "beef_feedlot_extension",
  },
  {
    value: "Beef Producer",
    label: "Naudanlihantuottaja",
    id: "beef_producer",
  },
  { value: "Breeder", label: "Kasvattaja", id: "breeder" },
  {
    value: "Business Administrator / Receptionist",
    label: "Liiketoiminnan ylläpitäjä / Vastaanottovirkailija",
    id: "business_administrator_receptionist",
  },
  {
    value: "Business Owner / Partner",
    label: "Yrityksen omistaja / Kumppani",
    id: "business_owner_partner",
  },
  { value: "Clinic Buyer", label: "Clinic Buyer", id: "clinic_buyer" },
  {
    value: "Consulting Nutritionist",
    label: "Konsultoiva ravitsemustieteilijä",
    id: "consulting_nutritionist",
  },
  {
    value: "Corporate Employee Non DVM",
    label: "Yrityksen eläinlääkintätyöntekijä (ei sairaala)",
    id: "corporate_employee_non_dvm",
  },
  {
    value: "Dairy Producer",
    label: "Maidontuottaja",
    id: "dairy_producer",
  },
  { value: "Distributor", label: "Jakelija", id: "distributor" },
  {
    value: "Distributor Rep, Field Based",
    label: "Jakelujen edustaja, Kenttäpohjainen",
    id: "distributor_rep_field_based",
  },
  {
    value: "Distributor Rep, Inside",
    label: "Jakelujen edustaja, Sisäinen",
    id: "distributor_rep_inside",
  },
  {
    value: "Educational Institution - Highschool Student",
    label: "Oppilaitos - Lukio-opiskelija",
    id: "educational_institution_highschool_student",
  },
  {
    value: "Educational Institution - TAFE Student",
    label: "Oppilaitos - TAFE-opiskelija",
    id: "educational_institution_tafe_student",
  },
  {
    value: "Educational Institution - University Student",
    label: "Oppilaitos - Yliopisto-opiskelija",
    id: "educational_institution_university_student",
  },
  { value: "Groomer", label: "Trimmaaja", id: "groomer" },
  {
    value: "Marketing Associate",
    label: "Marketing Associate",
    id: "marketing_associate",
  },
  {
    value: "Medical / Clinic Director",
    label: "Lääkäri-/Klinikkajohtaja",
    id: "medical_clinic_director",
  },
  {
    value: "Nutrition / Feed Sales",
    label: "Ravitsemus / Rehumyynti",
    id: "nutrition_feed_sales",
  },
  {
    value: "Nutritional Professional",
    label: "Ravitsemusalan ammattilainen",
    id: "nutritional_professional",
  },
  { value: "Nutritionist", label: "Ravitsemustieteilijä", id: "nutritionist" },
  {
    value: "Office / Practice Manager",
    label: "Toimisto-/Vastaanoton johtaja",
    id: "office_practice_manager",
  },
  { value: "OTC Retailer", label: "OTC-jälleenmyyjä", id: "otc_retailer" },
  { value: "Pharmacist", label: "Apteekkari", id: "pharmacist" },
  {
    value: "Pharmacy - Staff",
    label: "Apteekki - Henkilökunta",
    id: "pharmacy_staff",
  },
  { value: "Pig Producer", label: "Siantuottaja", id: "pig_producer" },
  {
    value: "Poultry Producer",
    label: "Siipikarjantuottaja",
    id: "poultry_producer",
  },
  {
    value: "Practice Owner, Non DVM",
    label: "Vastanoton omistaja, ei eläinlääkäri",
    id: "practice_owner_non_dvm",
  },
  {
    value: "Purchasing Agent",
    label: "Purchasing Agent",
    id: "purchasing_agent",
  },
  {
    value: "Receptionist / Client Service",
    label: "Vastaanottovirkailija/Asiakaspalvelu",
    id: "receptionist_client_service",
  },
  {
    value: "Reseller Store - Staff",
    label: "Jälleenmyyjäkauppa - Henkilökunta",
    id: "reseller_store_staff",
  },
  {
    value: "Producer - Mixed/Other",
    label: "Tuottaja - Sekalainen/Muu",
    id: "producer_mixed_other",
  },
  { value: "Retail Staff", label: "Retail Staff", id: "retail_staff" },
  {
    value: "Retail Store Manager",
    label: "Retail Store Manager",
    id: "retail_store_manager",
  },
  {
    value: "Retailer",
    label: "Vähittäismyyjä",
    id: "retailer",
  },
  {
    value: "Sheep Producer",
    label: "Lampuri",
    id: "sheep_producer",
  },
  { value: "SQP", label: "RAMA / SQP", id: "sqp" },
  { value: "Student", label: "Student", id: "student" },
  { value: "Student RAMA", label: "Opiskelija RAMA", id: "student_rama" },
  {
    value: "Tierarzt/ Tierärztin",
    label: "Eläinlääkäri",
    id: "tierarzt_tierarztin",
  },
  { value: "Trainer", label: "Kouluttaja", id: "trainer" },
  { value: "Veterinarian", label: "Eläinlääkäri", id: "veterinarian" },
  {
    value: "Veterinarian, Practice Owner",
    label: "Eläinlääkäri, Vastanoton omistaja",
    id: "veterinarian_practice_owner",
  },
  {
    value: "Veterinary Assistant",
    label: "Eläinlääkäriavustaja",
    id: "veterinary_assistant",
  },
  {
    value: "Veterinary Nurse",
    label: "Eläinhoitaja",
    id: "veterinary_nurse",
  },
  {
    value: "Veterinary Practice - Other",
    label: "Eläinlääkäriasema - Muu",
    id: "veterinary_practice_other",
  },
  {
    value: "Veterinary Practice - Vet",
    label: "Eläinlääkäriasema - Eläinlääkäri",
    id: "veterinary_practice_vet",
  },
  {
    value: "Veterinary Practice - Vet Nurse",
    label: "Eläinlääkäriasema - Eläinhoitaja",
    id: "veterinary_practice_vet_nurse",
  },
  {
    value: "Veterinary Specialist",
    label: "Eläinlääkäriasiantuntija",
    id: "veterinary_specialist",
  },
  {
    value: "Veterinary Student",
    label: "Eläinlääketieteen opiskelija",
    id: "veterinary_student",
  },
  {
    value: "Veterinary Surgeon",
    label: "Eläinlääkäri",
    id: "veterinary_surgeon",
  },
  {
    value: "Veterinary Technician",
    label: "Eläinlääkintäteknikko",
    id: "veterinary_technician",
  },
  { value: "Wholesaler", label: "Tukkumyyjä", id: "wholesaler" },
];

const SALUTATIONS = [
  {
    label: "Tri",
    value: "Dr.",
    id: "dr",
  },
  {
    label: "Herra",
    value: "M.",
    id: "m",
  },
  {
    label: "Neiti",
    value: "Miss",
    id: "miss",
  },
  {
    label: "Herra",
    value: "Mr.",
    id: "mr",
  },
  {
    label: "Rouva",
    value: "Mrs.",
    id: "mrs",
  },
  {
    label: "Rouva/Neiti",
    value: "Ms.",
    id: "ms",
  },
  {
    label: "Mx.",
    value: "Mx.",
    id: "mx",
  },
  {
    label: "Professori",
    value: "Professor",
    id: "professor",
  },
];

export { BUSINESS_TYPES, FIELDS, ROLES, SALUTATIONS };
